/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './cost-guide.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/common';
import * as import3 from '../../shared/decorator/header/header.component.ngfactory';
import * as import4 from '../../../../app/shared/decorator/header/header.component';
import * as import5 from '@angular/router';
import * as import6 from '../../../../app/cost-guide/cost-guide-page/cost-guide.component';
import * as import7 from '../../shared/menu/menu.component.ngfactory';
import * as import8 from '../../../../app/shared/menu/menu.component';
import * as import9 from '../../../../modules/transfer-state/transfer-state';
import * as import10 from '../../../../../common/utils/costguideutils';
import * as import11 from '@angular/platform-browser';
import * as import12 from '../../../../app/shared/services/stringutils';
import * as import13 from '../../../../app/shared/sdk/services/custom/FixrAPI';
import * as import14 from '../../../../app/shared/type-builder/type.builder';
const styles_CostGuideComponent:any[] = [import0.styles];
export const RenderType_CostGuideComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_CostGuideComponent,
  data: {}
}
);
function View_CostGuideComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',[[
        'id',
        'averagePriceDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef])
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import1.ɵunv(v,1,0,import1.ɵnov(v,2).transform(co.costGuideView))) == null)? (null as any): tmp_0_0.averagePriceDescription);
    ck(v,1,0,currVal_0);
  });
}
function View_CostGuideComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'p',[[
        'class',
        'pricesRangeDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef])
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import1.ɵunv(v,1,0,import1.ɵnov(v,2).transform(co.costGuideView))) == null)? (null as any): tmp_0_0.pricesRangeDescription);
    ck(v,1,0,currVal_0);
  });
}
function View_CostGuideComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'data',[[
        'id',
        'lowerPriceDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef])
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import1.ɵunv(v,1,0,import1.ɵnov(v,2).transform(co.costGuideView))) == null)? (null as any): tmp_0_0.lowerPriceDescription);
    ck(v,1,0,currVal_0);
  });
}
function View_CostGuideComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'data',[[
        'id',
        'upperPriceDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef])
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import1.ɵunv(v,1,0,import1.ɵnov(v,2).transform(co.costGuideView))) == null)? (null as any): tmp_0_0.upperPriceDescription);
    ck(v,1,0,currVal_0);
  });
}
function View_CostGuideComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),18,'p',[[
        'class',
        'costData pricesRangeDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Prices range from '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'data',[[
        'id',
        'lowerPrice'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostGuideComponent_4)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),[' to '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'data',[[
        'id',
        'upperPrice'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostGuideComponent_5)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),[' and also vary depending on your zipcode:']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    var tmp_1_0:any = (null as any);
    const currVal_1:boolean = !!(((tmp_1_0 = import1.ɵunv(v,8,0,import1.ɵnov(v,9).transform(co.costGuideView))) == null)? (null as any): tmp_1_0.lowerPriceDescription);
    ck(v,8,0,currVal_1);
    var tmp_3_0:any = (null as any);
    const currVal_3:boolean = !!(((tmp_3_0 = import1.ɵunv(v,16,0,import1.ɵnov(v,17).transform(co.costGuideView))) == null)? (null as any): tmp_3_0.upperPriceDescription);
    ck(v,16,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import1.ɵunv(v,4,0,import1.ɵnov(v,5).transform(co.costGuideView))) == null)? (null as any): tmp_0_0.lowerPrice);
    ck(v,4,0,currVal_0);
    var tmp_2_0:any = (null as any);
    const currVal_2:any = (((tmp_2_0 = import1.ɵunv(v,13,0,import1.ɵnov(v,14).transform(co.costGuideView))) == null)? (null as any): tmp_2_0.upperPrice);
    ck(v,13,0,currVal_2);
  });
}
function View_CostGuideComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'pricesRangeDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Prices vary depending on your zipcode:']))
  ]
  ,(null as any),(null as any));
}
function View_CostGuideComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef])
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import1.ɵunv(v,1,0,import1.ɵnov(v,2).transform(co.costGuideView))) == null)? (null as any): tmp_0_0.averagePriceDescription);
    ck(v,1,0,currVal_0);
  });
}
function View_CostGuideComponent_9(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'li',[[
        'class',
        'city'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.cityAndState;
    ck(v,2,0,currVal_0);
    const currVal_1:any = v.context.$implicit.typicalCost;
    ck(v,4,0,currVal_1);
  });
}
function View_CostGuideComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),23,'div',[
      [
        'class',
        'well'
      ]
      ,
      [
        'id',
        'citiesCostSummary'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h4',[[
        'class',
        'price'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Cost by city'])),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostGuideComponent_8)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'ul',[
      [
        'class',
        'unstyled-list leaders'
      ]
      ,
      [
        'id',
        'costByCityList'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CostGuideComponent_9)),
    import1.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'pricesRangeDescription'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Local costs have been calculated by accounting for labor and material cost differences across different cities. To get accurate cost estimates, indicate yours:'])),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'p',[[
        'style',
        'text-align: center; padding-top: 10px;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-lg btn-new-job'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showCostGuideForm()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Get free estimates'])),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:boolean = !!(((tmp_0_0 = import1.ɵunv(v,6,0,import1.ɵnov(v,7).transform(co.costGuideView))) == null)? (null as any): tmp_0_0.averagePriceDescription);
    ck(v,6,0,currVal_0);
    const currVal_1:any = co.cities;
    ck(v,12,0,currVal_1);
  },(null as any));
}
export function View_CostGuideComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(402653184,1,{contentContainer: 0}),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'header',([] as any[]),(null as any),(null as any),(null as any),import3.View_HeaderComponent_0,import3.RenderType_HeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import4.HeaderComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),90,'div',[
      [
        'class',
        'menu-perspective effect-moveright'
      ]
      ,
      [
        'id',
        'menu-perspective'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),84,'div',[[
        'class',
        'menu-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),81,'div',[[
        'class',
        'menu-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),78,'div',[
      [
        'class',
        'container'
      ]
      ,
      [
        'id',
        'cost-guide'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),75,'div',[
      [
        'class',
        'row'
      ]
      ,
      [
        'style',
        'padding-bottom: 50px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),27,'div',[[
        'class',
        'col-lg-8 col-md-12'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'cost-guide-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'bc'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[[
        'routerLink',
        '/cost-guides'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,25).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import5.RouterLinkWithHref,[
      import5.Router,
      import5.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['Cost Guides'])),
    (l()(),import1.ɵted((null as any),['  \n              '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-angle-right'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['  \n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'routerLink',
        '/cost-guides'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,31).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import5.RouterLinkWithHref,[
      import5.Router,
      import5.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['  \n              '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-angle-right'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '  \n              ',
      '\n              '
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵeld(16777216,[
      [
        1,
        3
      ]
      ,
      [
        'content',
        1
      ]

    ]
      ,(null as any),0,'div',[[
        'class',
        'content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),43,'div',[[
        'class',
        'col-lg-4 col-md-12'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),36,'div',[
      [
        'class',
        'well'
      ]
      ,
      [
        'id',
        'costSummary'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),9,'div',[[
        'id',
        'costSummaryTop'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                Typical cost is\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'h1',[
      [
        'class',
        'price costData'
      ]
      ,
      [
        'id',
        'averagePrice'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostGuideComponent_1)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'div',[[
        'id',
        'costSummaryBottom'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostGuideComponent_2)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),3,(null as any),View_CostGuideComponent_3)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),4,(null as any),View_CostGuideComponent_6)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'p',[[
        'style',
        'text-align: center; padding-top: 10px;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-lg btn-new-job'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import6.CostGuideComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showCostGuideForm()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Get free estimates'])),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CostGuideComponent_7)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(131072,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n\n          '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'menu',([] as any[]),(null as any),(null as any),(null as any),import7.View_MenuComponent_0,import7.RenderType_MenuComponent)),
    import1.ɵdid(4243456,(null as any),0,import8.MenuComponent,[
      'isBrowser',
      import9.TransferState,
      import10.CostGuideUtils
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.CostGuideComponent = v.component;
    const currVal_3:any = '/cost-guides';
    ck(v,25,0,currVal_3);
    const currVal_6:any = '/cost-guides';
    ck(v,31,0,currVal_6);
    var tmp_10_0:any = (null as any);
    const currVal_10:boolean = !!(((tmp_10_0 = import1.ɵunv(v,54,0,import1.ɵnov(v,55).transform(co.costGuideView))) == null)? (null as any): tmp_10_0.averagePriceDescription);
    ck(v,54,0,currVal_10);
    var tmp_11_0:any = (null as any);
    const currVal_11:boolean = !!(((tmp_11_0 = import1.ɵunv(v,61,0,import1.ɵnov(v,62).transform(co.costGuideView))) == null)? (null as any): tmp_11_0.pricesRangeDescription);
    ck(v,61,0,currVal_11);
    var tmp_12_0:any = (null as any);
    const currVal_12:boolean = (!!(((tmp_12_0 = import1.ɵunv(v,65,0,import1.ɵnov(v,66).transform(co.costGuideView))) == null)? (null as any): tmp_12_0.lowerPrice) || !!(((tmp_12_0 = import1.ɵunv(v,65,0,import1.ɵnov(v,67).transform(co.costGuideView))) == null)? (null as any): tmp_12_0.upperPrice));
    ck(v,65,0,currVal_12);
    var tmp_13_0:any = (null as any);
    const currVal_13:boolean = ((!!(((tmp_13_0 = import1.ɵunv(v,70,0,import1.ɵnov(v,71).transform(co.costGuideView))) == null)? (null as any): tmp_13_0.pricesRangeDescription) && !!(((tmp_13_0 = import1.ɵunv(v,70,0,import1.ɵnov(v,72).transform(co.costGuideView))) == null)? (null as any): tmp_13_0.lowerPrice)) && !!(((tmp_13_0 = import1.ɵunv(v,70,0,import1.ɵnov(v,73).transform(co.costGuideView))) == null)? (null as any): tmp_13_0.upperPrice));
    ck(v,70,0,currVal_13);
    var tmp_14_0:any = (null as any);
    const currVal_14:any = ((((tmp_14_0 = import1.ɵunv(v,84,0,import1.ɵnov(v,85).transform(co.costGuideView))) == null)? (null as any): tmp_14_0.group) <= 3);
    ck(v,84,0,currVal_14);
  },(ck,v) => {
    var co:import6.CostGuideComponent = v.component;
    var tmp_0_0:any = (null as any);
    const currVal_0:any = (((tmp_0_0 = import1.ɵunv(v,19,0,import1.ɵnov(v,20).transform(co.costGuideView))) == null)? (null as any): tmp_0_0.title);
    ck(v,19,0,currVal_0);
    const currVal_1:any = import1.ɵnov(v,25).target;
    const currVal_2:any = import1.ɵnov(v,25).href;
    ck(v,24,0,currVal_1,currVal_2);
    const currVal_4:any = import1.ɵnov(v,31).target;
    const currVal_5:any = import1.ɵnov(v,31).href;
    ck(v,30,0,currVal_4,currVal_5);
    var tmp_7_0:any = (null as any);
    const currVal_7:any = (((tmp_7_0 = import1.ɵunv(v,32,0,import1.ɵnov(v,33).transform(co.costGuideView))) == null)? (null as any): tmp_7_0.categoryName);
    ck(v,32,0,currVal_7);
    var tmp_8_0:any = (null as any);
    const currVal_8:any = (((tmp_8_0 = import1.ɵunv(v,36,0,import1.ɵnov(v,37).transform(co.costGuideView))) == null)? (null as any): tmp_8_0.title);
    ck(v,36,0,currVal_8);
    var tmp_9_0:any = (null as any);
    const currVal_9:any = (((tmp_9_0 = import1.ɵunv(v,50,0,import1.ɵnov(v,51).transform(co.costGuideView))) == null)? (null as any): tmp_9_0.averagePrice);
    ck(v,50,0,currVal_9);
  });
}
function View_CostGuideComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'costGuideComponent',([] as any[]),(null as any),(null as any),(null as any),View_CostGuideComponent_0,RenderType_CostGuideComponent)),
    import1.ɵdid(4374528,(null as any),0,import6.CostGuideComponent,[
      import1.Renderer2,
      import11.DOCUMENT,
      import5.Router,
      import5.ActivatedRoute,
      import11.Title,
      import12.StringUtils,
      import11.Meta,
      import10.CostGuideUtils,
      import9.TransferState,
      import13.FixrAPIApi,
      import14.DynamicTypeBuilder,
      'isBrowser'
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const CostGuideComponentNgFactory:import1.ComponentFactory<import6.CostGuideComponent> = import1.ɵccf('costGuideComponent',import6.CostGuideComponent,View_CostGuideComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/cost-guide/cost-guide-page/cost-guide.component.ngfactory.ts